import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// ============================================
// Public APIs
// ============================================
export const getPublicTestimonials = () => apiClient.get('/testimonials');
export const getTestimonial = (id) => apiClient.get(`/testimonials/${id}`);

// ============================================
// Auth APIs
// ============================================
export const adminLogin = (credentials) => apiClient.post('/admin/login', credentials);
export const adminSetup = (credentials) => apiClient.post('/admin/setup', credentials);
export const verifyAdmin = () => apiClient.get('/admin/verify');

// ============================================
// Admin Testimonial APIs
// ============================================
export const getAdminTestimonials = () => apiClient.get('/admin/testimonials');

export const createTestimonial = (data) => {
  return apiClient.post('/admin/testimonials', {
    title: data.title,
    description: data.description,
    rating: data.rating,
    time_to_finish: data.time_to_finish,
    image_urls: data.image_urls || [],
    published: data.published || false,
  });
};

export const updateTestimonial = (id, data) => {
  return apiClient.put(`/admin/testimonials/${id}`, {
    title: data.title,
    description: data.description,
    rating: data.rating,
    time_to_finish: data.time_to_finish,
    image_urls: data.image_urls,
    published: data.published,
  });
};

export const deleteTestimonial = (id) => apiClient.delete(`/admin/testimonials/${id}`);

// ============================================
// WebSocket connection
// ============================================
export const getWebSocketUrl = () => {
  try {
    const url = new URL(BACKEND_URL);
    const wsProtocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${url.host}/ws/testimonials`;
  } catch (e) {
    // Fallback for development
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${window.location.host}/ws/testimonials`;
  }
};

export default apiClient;

// ============================================
// API Documentation for Cloudflare Migration
// ============================================
/*
CLOUDFLARE MIGRATION NOTES
==========================

This API client is designed to work with both:
1. Current FastAPI backend
2. Future Cloudflare Workers backend

API Endpoints Used:
-------------------
- GET  /api/testimonials          - Fetch published testimonials
- GET  /api/testimonials/:id      - Fetch single testimonial
- POST /api/admin/login           - Admin authentication
- GET  /api/admin/verify          - Verify token
- GET  /api/admin/testimonials    - Fetch all testimonials (admin)
- POST /api/admin/testimonials    - Create testimonial
- PUT  /api/admin/testimonials/:id - Update testimonial
- DELETE /api/admin/testimonials/:id - Delete testimonial

WebSocket:
----------
- /ws/testimonials - For realtime updates

When migrating to Cloudflare:
1. Update REACT_APP_BACKEND_URL to Cloudflare Workers URL
2. WebSocket will need Durable Objects on Cloudflare
3. All other API calls remain the same
*/
